<template>
    <div class="product-form__input-row">
        <div class="input-row__inputs-container" ref="inputs">
            <slot name="inputs"></slot>
        </div>
        <div class="input-row__description">
            <slot name="description" v-if="focused"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                focused: false,
            }
        },
        mounted() {
            const inputs = this.$refs.inputs.getElementsByTagName('input')    

            for (let input of inputs) {
                    input.addEventListener('focus', () => {
                        this.focused = true;
                    })
                    input.addEventListener('blur', () => {
                        this.focused = false;
                    })

            }
        },
    }
</script>

<style scoped lang="scss">
    .product-form__input-row {
        display     : flex;
        height      : 80px;
        align-items : center;
    }

    .input-row__inputs-container {
        flex         : 1;
        margin-right : 20px;
    }

    .input-row__description {
        width      : 300px;
        word-break : break-word;
    }
</style>
